'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dDefault$002dSort from "./mealorama.-Default-Sort.js";
var $p;
/** @constructor */
function $c_Lmealorama_DefaultSort$() {
}
export { $c_Lmealorama_DefaultSort$ as $c_Lmealorama_DefaultSort$ };
$p = $c_Lmealorama_DefaultSort$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_DefaultSort$;
/** @constructor */
function $h_Lmealorama_DefaultSort$() {
}
export { $h_Lmealorama_DefaultSort$ as $h_Lmealorama_DefaultSort$ };
$h_Lmealorama_DefaultSort$.prototype = $p;
$p.m = (function() {
  return "DefaultSort";
});
$p.aSd = (function(x$0) {
  return new $j_mealorama$002e$002dDefault$002dSort.$c_Lmealorama_DefaultSort(x$0.g(0));
});
var $d_Lmealorama_DefaultSort$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_DefaultSort$, "mealorama.DefaultSort$", ({
  FK: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_DefaultSort$ as $d_Lmealorama_DefaultSort$ };
var $n_Lmealorama_DefaultSort$;
function $m_Lmealorama_DefaultSort$() {
  if ((!$n_Lmealorama_DefaultSort$)) {
    $n_Lmealorama_DefaultSort$ = new $c_Lmealorama_DefaultSort$();
  }
  return $n_Lmealorama_DefaultSort$;
}
export { $m_Lmealorama_DefaultSort$ as $m_Lmealorama_DefaultSort$ };
//# sourceMappingURL=mealorama.-Default-Sort$.js.map
